import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const containerVariants = tv({
  base: 'flex justify-center items-center box-border border rounded-lg',
  variants: {
    isFluid: {
      true: 'w-full h-full',
      false: 'h-fit w-fit',
    },
    base: {
      white: 'bg-base-white',
      gray: 'bg-gray-300',
      blue: 'bg-blue-200',
    },
    border: {
      false: 'border-transparent',
      true: 'border-gray-300',
    },
  },
  defaultVariants: {
    isFluid: false,
    base: 'white',
    border: true,
  },
});
export type ContainerProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof containerVariants> & {
    isFluid?: boolean;
    base?: string;
    border?: boolean;
  };

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, isFluid, base, border, ...props }, ref) => {
    return (
      <div
        className={cn(
          containerVariants({
            isFluid,
            base,
            border,
            className,
          }),
        )}
        ref={ref}
        {...props}
      >
        {props.children}
      </div>
    );
  },
);

Container.displayName = 'Container';
